// The five sections of one advice record. `key` is the exact field name the API
// and the tsp_advice table use; `tone` maps to a .tsp-pill-* / chip class.
export const ADVICE_SECTIONS = [
  { key: "best_areas", label: "Best Areas", tone: "green", hint: "Where and when distribution worked best." },
  { key: "mistakes", label: "Mistakes", tone: "maroon", hint: "What went wrong, so the next team can avoid it." },
  { key: "challenges", label: "Challenges", tone: "amber", hint: "What made this place difficult." },
  { key: "suggestions", label: "Suggestions", tone: "blue", hint: "What you would recommend to the next team." },
  { key: "future_opportunities", label: "Future Opportunities", tone: "purple", hint: "What could be done here later (events, fairs, seasons)." },
];

export const ADVICE_SECTION_BY_KEY = Object.fromEntries(ADVICE_SECTIONS.map((section) => [section.key, section]));

// Mirrors the server's limits (constants/tspKnowledge.js); the server enforces them.
export const ADVICE_SECTION_MIN = 1;
export const ADVICE_SECTION_MAX = 2000;
